export default __webpack_public_path__ + "static/media/money-wings.a18f56c3.png";